import { Action } from 'redux';
import { batch } from 'react-redux';

import { TThunkAction } from '../../types/redux';
import { FILTERS_SELECT_OFFER_TYPE_TYPE } from '../../constants/action_types';
import { EOfferType } from '../../utils/jsonQuery';
import { getMeta } from './getMeta';

export type TSelectOfferTypeType = 'filters/select_offer_type';

export interface ISelectOfferType extends Action<TSelectOfferTypeType> {
  type: TSelectOfferTypeType;
  offerType: EOfferType;
}

export type TSelectOfferType = ISelectOfferType;

export function selectOfferType(offerType: EOfferType): TThunkAction {
  return dispatch => {
    batch(() => {
      dispatch<TSelectOfferType>({
        type: FILTERS_SELECT_OFFER_TYPE_TYPE,
        offerType,
      });

      dispatch(getMeta());
    });
  };
}
